import { render, staticRenderFns } from "./FormVaiTro.vue?vue&type=template&id=30542947&"
import script from "./FormVaiTro.vue?vue&type=script&lang=js&"
export * from "./FormVaiTro.vue?vue&type=script&lang=js&"
import style0 from "./FormVaiTro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports